<!-- Do not change this file. -->

<template>
  <div v-if="isDebugMode">
    <!-- Offcanvas -->
    <div
      class="debugOffCanvas offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasRight"
      aria-labelledby="offcanvasRightLabel"
    >
      <div class="offcanvas-header">
        <h1 id="offcanvasRightLabel" class="h5">Debugger</h1>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <div class="card">
          <div class="card-body">
            <AdminReset />
            <div class="d-flex justify-content-between align-items-center">
              <DebugInterface
                :showDebugUI="showDebugUI"
                @update:showDebugUI="handleShowDebugUIUpdate"
              />
              <button
                type="button"
                class="btn btn-danger btn-sm mt-2"
                @click="resetApp"
              >
                Reset My Data
              </button>
            </div>
          </div>
        </div>
        <DebugAuth />
        <DebugEnv />
        <DebugDatastore />
      </div>
    </div>

    <!-- Footer Content-->
    <div class="d-flex my-auto">
      <TheBreakpoints />
      <button
        class="ms-3 nav-link text-primary my-auto"
        @click="toggleVisibility()"
      >
        Debugger
      </button>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import { mapGetters, mapActions } from "vuex";
import { Offcanvas } from "bootstrap";
import DebugAuth from "@/components/debug/DebugAuth.vue";
import DebugEnv from "@/components/debug/DebugEnv.vue";
import DebugInterface from "@/components/activity/DebugInterface.vue";
import DebugDatastore from "@/components/debug/DebugDatastore.vue";
import DatastoreAPI from "@/helpers/DatastoreAPI";
import AdminReset from "@/admin/components/AdminReset.vue";

import TheBreakpoints from "@/components/debug/TheBreakpoints.vue";

export default {
  name: "TheDebugger",
  mixins: [DatastoreAPI],
  data() {
    return {
      offCanvas: {},
      visible: true
    };
  },
  components: {
    DebugAuth,
    DebugEnv,
    DebugDatastore,
    DebugInterface,
    TheBreakpoints,
    AdminReset
  },
  computed: {
    ...mapGetters({ isDebugMode: "isDebugMode", showDebugUI: "showDebugUI" })
  },
  methods: {
    ...mapActions({ setShowDebugUI: "setShowDebugUI" }),
    toggleVisibility() {
      this.offCanvas.toggle();
    },
    handleShowDebugUIUpdate() {
      const toggledValue = !this.showDebugUI;
      this.setShowDebugUI(toggledValue);
    },
    resetApp() {
      if (
        confirm(
          "Reset app? This will delete your data and clear local storage."
        )
      ) {
        try {
          localStorage.clear();
        } catch {
          // localStorage may be unavailable
        }
        if (this.validate()) {
          this.deleteEntry(() => {
            location.reload();
          });
        } else {
          location.reload();
        }
      }
    }
  },
  mounted() {
    if (this.isDebugMode) {
      const offcanvasElement = document.querySelector(".debugOffCanvas");
      this.offCanvas = new Offcanvas(offcanvasElement);
    }
  }
};
</script>

<style scoped>
.debugOffCanvas {
  width: 600px !important;
}

.nav-link {
  margin-top: 1px;
}
.nav-link:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
